import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=0e87d566&scoped=true&"
import script from "./basicInformation.vue?vue&type=script&lang=js&"
export * from "./basicInformation.vue?vue&type=script&lang=js&"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=0e87d566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e87d566",
  null
  
)

export default component.exports